import { render, staticRenderFns } from "./RegattaTable.vue?vue&type=template&id=4c7ea43b&scoped=true&"
import script from "./RegattaTable.vue?vue&type=script&lang=js&"
export * from "./RegattaTable.vue?vue&type=script&lang=js&"
import style0 from "./RegattaTable.vue?vue&type=style&index=0&id=4c7ea43b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7ea43b",
  null
  
)

export default component.exports